import { IDominioResponseQA } from "../../interfaces/dados-pessoais/dominio-qa-response.interface";

export const ORIGEM_RENDA: IDominioResponseQA = {
  codigo_dominio: 0,
  descricao_conceito_dominio: '',
  headers: null,
  nome_dominio: '',
  nome_referencia_dominio: '',
  valores_dominio: [
    {
      "codigo_valor_dominio": 11829,
      "codigo_referencia_valor_dominio": "A",
      "nome_resumido_valor_dominio": "EMPREGADO EMPRESA PRIVADA",
      "nome_completo_valor_dominio": "EMPREGADO EMPRESA PRIVADA",
      "descricao_conceito_valor_dominio": "EMPREGADO EMPRESA PRIVADA"
    },
    {
      "codigo_valor_dominio": 11830,
      "codigo_referencia_valor_dominio": "B",
      "nome_resumido_valor_dominio": "PROFISSIONAL LIBERAL",
      "nome_completo_valor_dominio": "PROFISSIONAL LIBERAL",
      "descricao_conceito_valor_dominio": "PROFISSIONAL LIBERAL"
    },
    {
      "codigo_valor_dominio": 11831,
      "codigo_referencia_valor_dominio": "C",
      "nome_resumido_valor_dominio": "AUTONOMO",
      "nome_completo_valor_dominio": "AUTONOMO",
      "descricao_conceito_valor_dominio": "AUTONOMO"
    },
    {
      "codigo_valor_dominio": 11832,
      "codigo_referencia_valor_dominio": "D",
      "nome_resumido_valor_dominio": "SOCIO/ PROPRIETARIO EMPRESA",
      "nome_completo_valor_dominio": "SOCIO/ PROPRIETARIO EMPRESA",
      "descricao_conceito_valor_dominio": "SOCIO/ PROPRIETARIO EMPRESA"
    },
    {
      "codigo_valor_dominio": 11833,
      "codigo_referencia_valor_dominio": "E",
      "nome_resumido_valor_dominio": "PROPRIETARIO RURAL",
      "nome_completo_valor_dominio": "PROPRIETARIO RURAL",
      "descricao_conceito_valor_dominio": "PROPRIETARIO RURAL"
    },
    {
      "codigo_valor_dominio": 11834,
      "codigo_referencia_valor_dominio": "F",
      "nome_resumido_valor_dominio": "ESTUDANTE/ BOLSISTA",
      "nome_completo_valor_dominio": "ESTUDANTE/ BOLSISTA",
      "descricao_conceito_valor_dominio": "ESTUDANTE/ BOLSISTA"
    },
    {
      "codigo_valor_dominio": 11835,
      "codigo_referencia_valor_dominio": "G",
      "nome_resumido_valor_dominio": "SERVIDOR PUBLICO ESTATUTARIO",
      "nome_completo_valor_dominio": "SERVIDOR PUBLICO ESTATUTARIO",
      "descricao_conceito_valor_dominio": "SERVIDOR PUBLICO ESTATUTARIO"
    },
    {
      "codigo_valor_dominio": 11836,
      "codigo_referencia_valor_dominio": "H",
      "nome_resumido_valor_dominio": "SERVIDOR PUBLICO/ ECONOMIA MISTA (CLT)",
      "nome_completo_valor_dominio": "SERVIDOR PUBLICO/ ECONOMIA MISTA (CLT)",
      "descricao_conceito_valor_dominio": "SERVIDOR PUBLICO/ ECONOMIA MISTA (CLT)"
    },
    {
      "codigo_valor_dominio": 11837,
      "codigo_referencia_valor_dominio": "I",
      "nome_resumido_valor_dominio": "INVESTIDOR RECEBENDO RENDIMENTOS",
      "nome_completo_valor_dominio": "INVESTIDOR RECEBENDO RENDIMENTOS",
      "descricao_conceito_valor_dominio": "INVESTIDOR RECEBENDO RENDIMENTOS"
    },
    {
      "codigo_valor_dominio": 11838,
      "codigo_referencia_valor_dominio": "J",
      "nome_resumido_valor_dominio": "BENEFICIARIO PENSAO ALIMENTICIA",
      "nome_completo_valor_dominio": "BENEFICIARIO PENSAO ALIMENTICIA",
      "descricao_conceito_valor_dominio": "BENEFICIARIO PENSAO ALIMENTICIA"
    },
    {
      "codigo_valor_dominio": 11839,
      "codigo_referencia_valor_dominio": "L",
      "nome_resumido_valor_dominio": "APOSENTADO/ PENSIONISTA",
      "nome_completo_valor_dominio": "APOSENTADO/ PENSIONISTA",
      "descricao_conceito_valor_dominio": "APOSENTADO/ PENSIONISTA"
    },
    {
      "codigo_valor_dominio": 11840,
      "codigo_referencia_valor_dominio": "M",
      "nome_resumido_valor_dominio": "PROPRIETARIO DE IMOVEL RECEBENDO ALUGUEL",
      "nome_completo_valor_dominio": "PROPRIETARIO DE IMOVEL RECEBENDO ALUGUEL",
      "descricao_conceito_valor_dominio": "PROPRIETARIO DE IMOVEL RECEBENDO ALUGUEL"
    },
    {
      "codigo_valor_dominio": 11841,
      "codigo_referencia_valor_dominio": "N",
      "nome_resumido_valor_dominio": "DO LAR/ DONA DE CASA",
      "nome_completo_valor_dominio": "DO LAR/ DONA DE CASA",
      "descricao_conceito_valor_dominio": "DO LAR/ DONA DE CASA"
    },
    {
      "codigo_valor_dominio": 11842,
      "codigo_referencia_valor_dominio": "O",
      "nome_resumido_valor_dominio": "NAO ESPECIFICADA ANTERIORMENTE",
      "nome_completo_valor_dominio": "NAO ESPECIFICADA ANTERIORMENTE",
      "descricao_conceito_valor_dominio": "NAO ESPECIFICADA ANTERIORMENTE"
    },
    {
      "codigo_valor_dominio": 11843,
      "codigo_referencia_valor_dominio": "P",
      "nome_resumido_valor_dominio": "BENEFICIARIO INSS",
      "nome_completo_valor_dominio": "BENEFICIARIO INSS",
      "descricao_conceito_valor_dominio": "BENEFICIARIO INSS"
    },
    {
      "codigo_valor_dominio": 11845,
      "codigo_referencia_valor_dominio": "R",
      "nome_resumido_valor_dominio": "MILITAR",
      "nome_completo_valor_dominio": "MILITAR",
      "descricao_conceito_valor_dominio": "MILITAR"
    },
    {
      "codigo_valor_dominio": 11846,
      "codigo_referencia_valor_dominio": "S",
      "nome_resumido_valor_dominio": "MICRO EMPRESARIO",
      "nome_completo_valor_dominio": "MICRO EMPRESARIO",
      "descricao_conceito_valor_dominio": "MICRO EMPRESARIO"
    },
    {
      "codigo_valor_dominio": 12229,
      "codigo_referencia_valor_dominio": "K",
      "nome_resumido_valor_dominio": "MICROEMPREENDEDOR INDIVIDUAL (MEI)",
      "nome_completo_valor_dominio": "MICROEMPREENDEDOR INDIVIDUAL (MEI)",
      "descricao_conceito_valor_dominio": "MICROEMPREENDEDOR INDIVIDUAL (MEI)"
    },
    {
      "codigo_valor_dominio": 12230,
      "codigo_referencia_valor_dominio": "Z",
      "nome_resumido_valor_dominio": "NAO EXERCE ATIVIDADE REMUNERADA",
      "nome_completo_valor_dominio": "NAO EXERCE ATIVIDADE REMUNERADA",
      "descricao_conceito_valor_dominio": "NAO EXERCE ATIVIDADE REMUNERADA"
    }
  ]
}